import QrcodeVue from 'qrcode.vue'
import {DoccliService} from '../../../../providers/DoccliService.js';
const doccliService = new DoccliService();
import {AppService} from '../../../../providers/AppService.js';
const appService = new AppService();

import {SouscriptionService} from '../../../../providers/SouscriptionService.js';
const souscriptionService = new SouscriptionService();

import { minLength,maxLength,email } from 'vuelidate/lib/validators'


let msgServer;
export default {
    name: "ProgressScan",
     data () {
    return {
      tabs: null,
      text: 'chargement en cours...',
      showWait: true,
      message:'',
      dialogAriadSign: true,
      ifrmLoaded:true,
      token:null,
      callbackUrl:null,      
      codeVendeur:'',
      offreSelected:'',      
      optionsSelected:[],
      isDevicePC:false, 
      qrcodeSize: 200,
      webFlowSign: '', 
      sendLink: true,
      contactEmail:null,
      contactNumMobile:null,
      linkType : 'webflowSign',
      loading : false,
      loadingSendLink : false

    }
  },
  validations: {
    contactNumMobile: { minLength: minLength(10),maxLength: maxLength(10) },    
    contactEmail: { email }
  },
  computed: {
    mobileErrors () {
      const errors = []
      if (!this.$v.contactNumMobile.$dirty) return errors
      !this.$v.contactNumMobile.maxLength && errors.push('Numero à 10 chiffres')
      !this.$v.contactNumMobile.minLength && errors.push('Numero à 10 chiffres')
      return errors
    },
    emailErrors () {
      const errors = []
      //this.errorEmail="";
      if (!this.$v.contactEmail.$dirty) return errors
      !this.$v.contactEmail.email && errors.push('Adresse email invalide')
      //if(this.errorEmail != '') errors.push(this.errorEmail)
      return errors
    }
  },
  components: {
    QrcodeVue
  }, 
  beforeMount: function () {
    this.token = this.$root.token;
    this.callbackUrl = this.$root.callback;
    this.isDevicePC = this.$globalService.isDevicePC(this.$device);
    
  },
  mounted: function () {
   
    
    var sessionSouscription = this.$globalService.getSessionSouscription();
    if(this.token){      
      if(sessionSouscription == null || !sessionSouscription.doccli_id)  {    
        this.getDoccliByAccessToken();
      }else{
        if(this.$globalService.getSessionSouscription().webflow_signature_url){
          if(this.$root.user.type != 'TLV'){
            if(this.isDevicePC)
              this.getQrcodeSign();
            else
              this.iframeSign();
          }
        }else{
          this.getDoccliByAccessToken();
        }
      }
    }else{    
      if(this.$globalService.getSessionSouscription().webflow_signature_url){
        if(this.$root.user.type != 'TLV'){
          if(this.isDevicePC)
            this.getQrcodeSign();
          else
            this.iframeSign();
        }else
          this.sendLink = false;

      }else{
        this.offreSelected= sessionSouscription.offreChoisie.id;
        this.options = sessionSouscription.optionsChoisies;
        this.codeVendeur = this.$root.user.codevendeur;

        this.options.forEach(opt => {
          this.optionsSelected.push(opt.id);
        });

        this.signDocument();
      }
    }
    
    if(this.$root.user.type == 'TLV')
      this.showWait = false;
  },
  beforeDestroy() {
    // Make sure to close the connection with the events server
    // when the component is destroyed, or we'll have ghost connections!
    if(msgServer)
      msgServer.close();
  },

  methods: {
    
    confirmAnnuler: function(){
      this.dialogAriadSign = false;
      msgServer.close();
      if(!this.token)
        this.$router.push({name: 'ChoixCategorieOffre'});
      else
        this.callback();
      

    },
    callback:function(){      
      this.$root.logoutToken();      
      this.showWait = false;
      if(this.callbackUrl)
        window.location.href=this.callbackUrl;

      
    },
    getDoccliByAccessToken: function(){
      this.loading = true;      
      this.$root.progress = true;
      doccliService.getDoccliByAccessToken(this.token).then(res => {
           //this.loading = false;
          if (res) {
            if (res.err != "error") {
              this.$globalService.setSessionSouscription('doccli_id',res.params.doccli_id);
              this.$globalService.setSessionSouscription('existTiersPayeur',res.params.existTiersPayeur);
              
              this.signDocument();
            }else{
              this.dialogAriadSign = false;                 
              this.$root.progress = false;           
              this.showWait = false;
              this.$dialog.error({
                text: res.err_msg,
                title: 'Erreur',
                persistent: false,
                actions: {
                  false: 'Fermer'
                }
              })
            
            }
          }
        })
        .catch((error) => {
          this.loading = false;
          this.$root.progress = false;
          this.dialogAriadSign = false;
          this.$dialog.notify.error(this.$root.errorMessage, {
            position: "bottom-right",
            timeout: 5000,
          });
          return error;
        });
    },
    annuler:async function(){
      await this.$dialog.confirm({
        text: "Etes vous certain de vouloir annuler la signature des documents en cours?",
        type:'warning',
        title: 'Alert',
        actions: {
          false: 'Non',
          true: {
            color: 'red',
            text: 'Oui',
            handle: () => {
              this.confirmAnnuler();
            }
          }
        }
      })
    },
    signDocument: function(){
      this.loading = true;
      this.$root.progress = true;
      var sessionSouscription = this.$globalService.getSessionSouscription();
      if(sessionSouscription == null || !sessionSouscription.doccli_id){
        //this.loading = false;
        this.$root.progress = false;
        this.dialogAriadSign = false;      
        this.sendLink = true;  
        this.showWait = false;
        this.$dialog.error({
          text: "Une erreur s'est produite",
          title: 'Erreur',
          persistent: false,
          actions: {
            false: 'Fermer'
          }
        })
      }
      //set type de signature
      this.$globalService.setSessionSouscription('typeSignProgress','webflowsign');  
      doccliService.webflowsign(sessionSouscription.doccli_id,this.codeVendeur,this.offreSelected, this.optionsSelected).then(res => { 
          //this.loading = false;
          this.loading = false;
        this.$root.progress = false;
          if(res){
            if (res.err !='error') {
              this.$globalService.setSessionSouscription('webflow_signature_url',res.params.webflow_signature_url);   
              this.$globalService.setSessionSouscription('souscriptionId',res.params.souscriptionId); 
              this.$globalService.setSessionSouscription('active_rdv',res.params.active_rdv);             
           
              //récuperation dans la session
              if(this.$root.user.type != 'TLV'){
                if(this.isDevicePC)
                  this.getQrcodeSign();
                else
                  this.iframeSign();
              }else
                this.sendLink = false;         
            }else{
                    
              this.sendLink = true;  
              this.$root.progress = false;
              this.$dialog.error({
                text: res.err_msg,
                title: 'Erreur',
                persistent: false,
                actions: {
                  false: 'Fermer'
                }
              })
            
            }
          }
        }).catch(error=>{
                
              this.sendLink = true;  
              this.$root.progress = false;
              this.dialogAriadSign = false;
              this.showWait = false;
              this.loading = false;
              this.$dialog.notify.error(this.$root.errorMessage, {
                        position: 'bottom-right',
                        timeout: 5000
                      })
            return error;
          })
      //this.$router.push({path: '/souscription/scandocuments'});
    },
    sendAriadNextLinkBySmsAndEmail: function(){
      var sessionSouscription = this.$globalService.getSessionSouscription();
      if(!this.$globalService.getSessionSouscription().typeSignProgress)
        this.$globalService.setSessionSouscription('typeSignProgress','webflowsign');  
      this.loadingSendLink = true;
      souscriptionService.sendAriadNextLinkBySmsAndEmail(this.linkType,sessionSouscription.webflow_signature_url,this.contactEmail, this.contactNumMobile).then(res => {
           this.loadingSendLink = false;
          if (res) {
            if (res.err != "error") {
              this.sendLink = true;
              this.showWait = true;
              
              this.$dialog.notify.warning(res.err_msg, {
                position: "bottom-right",
                timeout: 5000,
              });
              this.serverSentEvent();
            }else{
              //this.dialogAriad = false;
              this.$dialog.error({
                text: res.err_msg,
                title: 'Erreur',
                persistent: false,
                actions: {
                  false: 'Fermer'
                }
              })
            
            }
          }
        })
        .catch((error) => {
          this.loadingSendLink = false;
          //this.dialogAriad = false;
          this.$dialog.notify.error(this.$root.errorMessage, {
            position: "bottom-right",
            timeout: 5000,
          });
          return error;
        });
    },
    iframeSign: function(){

       //récuperation dans la session
       var sessionSouscription = this.$globalService.getSessionSouscription();
       if(sessionSouscription != null && sessionSouscription.webflow_signature_url){
       
       

           // utilisation avec iframe
           var iframe = this.$refs.ifrmSign;
           iframe.src = sessionSouscription.webflow_signature_url;
           //iframe.src = "https://lpcybernet.com";
           this.dialogAriadSign = true;

           //window.location.assign(sessionSouscription.sdkwebScan);
           //window.location.href = sessionSouscription.sdkwebScan;
             //***************************** PARTIE SSE */
             this.$sse(appService.getBaseUrl()+'/sse/sse_sign.php?idSouscription='+sessionSouscription.souscriptionId, { format: 'json' })
               .then(sse => {
                
                  
                this.$root.progress = false;
                 // Store SSE object at a higher scope
                 msgServer = sse;
         
                 //si statut progress ne fais rien 
                 sse.subscribe('PROGRESS', () => {
                   this.message = 'TRAITEMENT EN COURS !!!';
                 });

                 //si statut SIGNATURE_WEBFLOW_ENDED redirection vers RecapSignAutprev pour tiers payeur ok RecapSignOk
                 sse.subscribe('SIGNATURE_WEBFLOW_ENDED', () => {
                   this.message = "ANALYSE EN COURS DES DOCUMENTS !!!";
                   msgServer.close();
                   this.showWait = false;
                   if(this.$globalService.getSessionSouscription().typeSignProgress == 'webflowsign' && sessionSouscription.existTiersPayeur == 1)
                     this.$router.push({name: 'RecapSignAutprev'});
                   else{
                     if(this.$root.token)
                       this.$router.push({name: 'RecapSignOkForToken'});
                     else
                       this.$router.push({name: 'RecapSignOk'});
                   }
                     
                 });

                 //si statut SIGNATURE_WEBFLOW_ENDED ne fais rien 
                 sse.subscribe('SIGNATURE_WEBFLOW_DECLINED', () => {
                   this.message = "ANALYSE EN COURS DES DOCUMENTS !!!";
                   msgServer.close();
                   this.showWait = false;
                   this.$router.push({name: 'RecapSignError'});
                     
                 });

                 //si statut SIGNATURE_WEBFLOW_ENDED ne fais rien 
                 sse.subscribe('SIGNATURE_WEBFLOW_BLOCKED', () => {
                   this.message = "ANALYSE EN COURS DES DOCUMENTS !!!";
                   msgServer.close();
                   this.showWait = false;
                   this.$router.push({name: 'RecapSignError'});
                     
                 });



                 sse.subscribe('SIGNATURE_WEBFLOW_ERROR', () => {
                   this.showWait = false;
                   this.$dialog.error({
                     text: this.$root.errorMessage,
                     title: 'Erreur',
                     persistent: false,
                     actions: {
                       false: 'Fermer'
                     }
                   })
                   msgServer.close();
                 });

                 sse.subscribe('ERROR', () => {
                  this.showWait = false;
                   this.$dialog.error({
                     text: this.$root.errorMessage,
                     title: 'Erreur',
                     persistent: false,
                     actions: {
                       false: 'Fermer'
                     }
                   })
                   msgServer.close();
                 });
             })
           .catch(err => {
              
              this.$root.progress = false;
               console.error('Failed to connect to server', err);
               this.$dialog.error({
                 text: this.$root.errorMessage,
                 title: 'Erreur',
                 persistent: false,
                 actions: {
                   false: 'Fermer'
                 }
               })
           });

         //******************* FIN SSE */

         //window.location.href = sessionSouscription.sdkwebScan;
       }else{
         this.dialogAriadSign = false;
         this.$root.progress = false;
         this.showWait = false;
         this.$dialog.error({
           text: this.$root.errorMessage,
           title: 'Erreur',
           persistent: false,
           actions: {
             false: 'Fermer'
           }
         })
       }
      
    },
    
    serverSentEvent: function(){
      //récuperation dans la session
      var sessionSouscription = this.$globalService.getSessionSouscription();
      if(sessionSouscription != null && sessionSouscription.webflow_signature_url){         
        this.webFlowSign = sessionSouscription.webflow_signature_url;
      

           //***************************** PARTIE SSE */
           this.$sse(appService.getBaseUrl()+'/sse/sse_sign.php?idSouscription='+sessionSouscription.souscriptionId, { format: 'json' })
             .then(sse => {
               // Store SSE object at a higher scope
               msgServer = sse;
               this.$root.progress = false;
               //si statut progress ne fais rien 
               sse.subscribe('PROGRESS', () => {
                 this.message = 'TRAITEMENT EN COURS !!!';
                 

               });//si statut SIGNATURE_WEBFLOW_ENDED redirection vers RecapSignAutprev pour tiers payeur ok RecapSignOk
               sse.subscribe('SIGNATURE_WEBFLOW_ENDED', () => {
                 this.message = "ANALYSE EN COURS DES DOCUMENTS !!!";
                 msgServer.close();
                 this.showWait = false;
                 if(this.$globalService.getSessionSouscription().typeSignProgress == 'webflowsign' && sessionSouscription.existTiersPayeur == 1)
                   this.$router.push({name: 'RecapSignAutprev'});
                 else{
                   if(this.$root.token)
                     this.$router.push({name: 'RecapSignOkForToken'});
                   else
                     this.$router.push({name: 'RecapSignOk'});
                 }
                   
               });

               //si statut SIGNATURE_WEBFLOW_ENDED ne fais rien 
               sse.subscribe('SIGNATURE_WEBFLOW_DECLINED', () => {
                 this.message = "ANALYSE EN COURS DES DOCUMENTS !!!";
                 msgServer.close();
                 this.showWait = false;
                 this.$router.push({name: 'RecapSignError'});
                   
               });

               //si statut SIGNATURE_WEBFLOW_ENDED ne fais rien 
               sse.subscribe('SIGNATURE_WEBFLOW_BLOCKED', () => {
                 this.message = "ANALYSE EN COURS DES DOCUMENTS !!!";
                 msgServer.close();
                 this.showWait = false;
                 this.$router.push({name: 'RecapSignError'});
                   
               });



               sse.subscribe('SIGNATURE_WEBFLOW_ERROR', () => {
                 this.showWait = false;
                 this.$dialog.error({
                   text: this.$root.errorMessage,
                   title: 'Erreur',
                   persistent: false,
                   actions: {
                     false: 'Fermer'
                   }
                 })
                 msgServer.close();
               });

               sse.subscribe('ERROR', () => {
                 this.showWait = false;
                 this.$dialog.error({
                   text: this.$root.errorMessage,
                   title: 'Erreur',
                   persistent: false,
                   actions: {
                     false: 'Fermer'
                   }
                 })
                 msgServer.close();
               });
           })
         .catch(err => {
          this.$root.progress = false;
             console.error('Failed to connect to server', err);
             this.$dialog.error({
               text: this.$root.errorMessage,
               title: 'Erreur',
               persistent: false,
               actions: {
                 false: 'Fermer'
               }
             })
         });

       //******************* FIN SSE */
      }else{
        this.$root.progress = false;
       this.$dialog.error({
         text: this.$root.errorMessage,
         title: 'Erreur',
         persistent: false,
         actions: {
           false: 'Fermer'
         }
       })
      }
     
   },
    getQrcodeSign: function(){
      //récuperation dans la session
      var sessionSouscription = this.$globalService.getSessionSouscription();
      if(sessionSouscription != null && sessionSouscription.webflow_signature_url){         
        this.webFlowSign = sessionSouscription.webflow_signature_url;
        
       this.$dialog.warning({
         text: "Scanner le qrcode avec votre tablette afin de signer les documents",
         title: 'Signature électronique',
         persistent: true
       });

           //***************************** PARTIE SSE */
           this.$sse(appService.getBaseUrl()+'/sse/sse_sign.php?idSouscription='+sessionSouscription.souscriptionId, { format: 'json' })
             .then(sse => {
               // Store SSE object at a higher scope
               msgServer = sse;
               this.$root.progress = false;
               //si statut progress ne fais rien 
               sse.subscribe('PROGRESS', () => {
                 this.message = 'TRAITEMENT EN COURS !!!';
                 

               });//si statut SIGNATURE_WEBFLOW_ENDED redirection vers RecapSignAutprev pour tiers payeur ok RecapSignOk
               sse.subscribe('SIGNATURE_WEBFLOW_ENDED', () => {
                 this.message = "ANALYSE EN COURS DES DOCUMENTS !!!";
                 msgServer.close();
                 this.showWait = false;
                 if(this.$globalService.getSessionSouscription().typeSignProgress == 'webflowsign' && sessionSouscription.existTiersPayeur == 1)
                   this.$router.push({name: 'RecapSignAutprev'});
                 else{
                   if(this.$root.token)
                     this.$router.push({name: 'RecapSignOkForToken'});
                   else
                     this.$router.push({name: 'RecapSignOk'});
                 }
                   
               });

               //si statut SIGNATURE_WEBFLOW_ENDED ne fais rien 
               sse.subscribe('SIGNATURE_WEBFLOW_DECLINED', () => {
                 this.message = "ANALYSE EN COURS DES DOCUMENTS !!!";
                 msgServer.close();
                 this.showWait = false;
                 this.$router.push({name: 'RecapSignError'});
                   
               });

               //si statut SIGNATURE_WEBFLOW_ENDED ne fais rien 
               sse.subscribe('SIGNATURE_WEBFLOW_BLOCKED', () => {
                 this.message = "ANALYSE EN COURS DES DOCUMENTS !!!";
                 msgServer.close();
                 this.showWait = false;
                 this.$router.push({name: 'RecapSignError'});
                   
               });



               sse.subscribe('SIGNATURE_WEBFLOW_ERROR', () => {
                 this.showWait = false;
                 this.$dialog.error({
                   text: this.$root.errorMessage,
                   title: 'Erreur',
                   persistent: false,
                   actions: {
                     false: 'Fermer'
                   }
                 })
                 msgServer.close();
               });

               sse.subscribe('ERROR', () => {
                 this.showWait = false;
                 this.$dialog.error({
                   text: this.$root.errorMessage,
                   title: 'Erreur',
                   persistent: false,
                   actions: {
                     false: 'Fermer'
                   }
                 })
                 msgServer.close();
               });
           })
         .catch(err => {
          this.$root.progress = false;
             console.error('Failed to connect to server', err);
             this.$dialog.error({
               text: this.$root.errorMessage,
               title: 'Erreur',
               persistent: false,
               actions: {
                 false: 'Fermer'
               }
             })
         });

       //******************* FIN SSE */
      }else{
        this.$root.progress = false;
       this.$dialog.error({
         text: this.$root.errorMessage,
         title: 'Erreur',
         persistent: false,
         actions: {
           false: 'Fermer'
         }
       })
      }
     
   }
  }
}